import React from "react";
import { useAuth } from "context/AuthContext";
import { useEmissionAmbienteStore } from "stores/emissionAmbienteStore";

/**
 * Sincroniza el store de ambiente DTE cuando hay sesión (layout admin).
 * Sin Provider: Zustand es global; este componente solo dispara el fetch.
 */
export default function EmissionAmbienteSync() {
  const { user, currentOrganization, isReadOnly } = useAuth();

  React.useEffect(() => {
    if (!user) {
      useEmissionAmbienteStore.getState().reset();
      return;
    }
    const ac = new AbortController();
    useEmissionAmbienteStore.getState().fetchForUser({
      organizationId: currentOrganization?.id,
      // Contador/solo-lectura: forzar producción (no ve ni cambia a certificación).
      forceAmbiente: isReadOnly ? "produccion" : undefined,
      signal: ac.signal,
    });
    return () => ac.abort();
  }, [user, currentOrganization?.id, isReadOnly]);

  return null;
}
